import ListItem from '../../../components/list/ListItem'
import TemplateView from '../../../TemplateView'

export class CountriesList extends TemplateView {
    constructor({
        onCountrySelected = countryId => {},
    }) {
        super()

        this.callbacks = {
            onCountrySelected,
        }

        this.state = {
            defaultTimeZoneCountry: null,
            countries: [],
        }

        this.onStatePropertyChanged('countries', () => this._updateList())
        this.onStatePropertyChanged('defaultTimeZoneCountry', (defaultTimeZoneCountry) => {
            this.$defaultTimeZoneCountry.toggle(defaultTimeZoneCountry !== null)
            if (defaultTimeZoneCountry !== null)
                this.$defaultTimeZoneCountry.text(defaultTimeZoneCountry.name)
        })
    }

    templateHtml() {
        return '<div class="countriesListWrapper">' +
               '    <div class="defaultTimeZoneCountry"/>' +
               '    <div class="countriesList"/>' +
               '</div>'
    }

    afterRender() {
        this.$defaultTimeZoneCountry = this.find('.defaultTimeZoneCountry')
        this.$countriesList = this.find('.countriesList')

        this.$defaultTimeZoneCountry.on('click', () => this.callbacks.onCountrySelected(this.state.defaultTimeZoneCountry))
    }

    _updateList() {
        this.$countriesList.empty()

        this.state.countries.forEach(country => {
            new ListItem({
                text: country.name,
                onClick: () => this.callbacks.onCountrySelected(country)
            }).init(this.$countriesList)
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/CountriesList.js